import axios from 'axios';
import { API_HOST } from '../consts';

const fetchEmailKind = async (params) => {
  const res = await axios.get(`${API_HOST}/persons/email_type`, { params });
  return res.data;
};

export default fetchEmailKind;
